import React, { useEffect, useMemo } from "react";
import { Box, Button, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import "moment/locale/id";
import {
  fetchListAbsensiBulanan,
  fetchOptionsAbsensiBulanan,
} from "state/absensiActions";
import SortableHeader from "components/SortableHeader";
import { FilterList } from "@mui/icons-material";
import CustomFilterModal from "./CustomFilterModal";
moment.locale("id");

const RekapAbsensiBulanan = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    list_absensi_bulanan,
    pagination_absensi_bulanan,
    options_absensi_bulanan,
  } = useSelector((state) => state.absensi);

  const [appliedFilters, setAppliedFilters] = React.useState({});
  const [openCustomFilter, setOpenCustomFilter] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [page, setPage] = React.useState(0);

  const columnSort = [
    { value: "id_karyawan", label: "ID Karyawan" },
    { value: "nama_karyawan", label: "Nama Karyawan" },
    { value: "cabang", label: "Cabang" },
    { value: "bulan", label: "Bulan" },
    { value: "total_telat", label: "Total Telat" },
    { value: "jumlah_hadir", label: "Jumlah Hadir" },
  ];

  const queryParams = useMemo(() => {
    const p = { page: page + 1, limit: rowsPerPage };
    if (appliedFilters.filter?.cabang?.length)
      p.cabang = appliedFilters.filter.cabang.join(",");
    if (appliedFilters.filter?.bulan?.length)
      p.bulan = appliedFilters.filter.bulan.join(",");
    if (appliedFilters.sort?.length) {
      const sortStr = appliedFilters.sort
        .filter((s) => s.column)
        .map((s) => `${s.column}:${s.order}`)
        .join(",");
      if (sortStr) p.sort = sortStr;
    }
    return p;
  }, [page, rowsPerPage, appliedFilters]);

  useEffect(() => {
    dispatch(fetchListAbsensiBulanan(queryParams));
  }, [dispatch, queryParams]);

  useEffect(() => {
    dispatch(fetchOptionsAbsensiBulanan());
  }, [dispatch]);

  const handleApplyCustomFilter = (filters) => {
    setPage(0);
    setAppliedFilters(filters);
  };

  const handleClearCustomFilter = () => {
    setPage(0);
    setAppliedFilters({});
  };
  // Count active filters
  const getActiveFilterCount = () => {
    let count = 0;

    // ✅ Filter
    if (appliedFilters.filter) {
      if (appliedFilters.filter.cabang?.length > 0) count++;
      if (appliedFilters.filter.bulan?.length > 0) count++;
    }

    // ✅ Sort (multiple)
    if (
      Array.isArray(appliedFilters.sort) &&
      appliedFilters.sort.some(
        (item) => item.column && item.column.trim() !== "",
      )
    ) {
      count++;
    }

    return count;
  };

  const columnsAbsensi = [
    {
      name: "id_karyawan",
      label: "ID Karyawan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "nama_karyawan",
      label: "Nama Karyawan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "cabang",
      label: "Nama Cabang",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },

    {
      name: "bulan",
      label: "Bulan",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "jumlah_hadir",
      label: "Jumlah Hadir",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "jumlah_izin",
      label: "Jumlah Izin",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "jumlah_tidak_hadir",
      label: "Jumlah Tidak Hadir",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "total_telat",
      label: "Total Telat (Menit)",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        // customBodyRender: (value) => `${Number(value).toFixed(0)}`,
        customBodyRender: (value) => {
          const isLate = value > 0;
          const style = isLate
            ? { color: "red", fontWeight: "bold" }
            : { color: "black" };
          return <span style={style}>{Number(value).toFixed(0)}</span>;
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    filter: false,
    fixedHeader: false,
    fixedSelectColumn: false,
    search: true,
    viewColumns: false,
    responsive: "standard",
    customToolbar: () => {
      const activeCount = getActiveFilterCount();
      return (
        <Button
          startIcon={<FilterList />}
          onClick={() => setOpenCustomFilter(true)}
          variant={activeCount > 0 ? "contained" : "outlined"}
          size="small"
          color={activeCount > 0 ? "primary" : "inherit"}
          sx={{
            mr: 1,
            ...(activeCount === 0 && {
              color: "text.secondary",
              borderColor: "text.secondary",
            }),
          }}
        >
          Filter {activeCount > 0 && `(${activeCount})`}
        </Button>
      );
    },
    serverSide: true,
    count: pagination_absensi_bulanan?.total ?? 0,
    page: page,
    rowsPerPageOptions: [25, 50, 75],
    rowsPerPage: rowsPerPage,
    onChangePage: (currentPage) => setPage(currentPage),
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
      setPage(0);
    },
  };

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="Rekap Absensi Bulanan"
        subtitle="Daftar absensi bulanan karyawan."
      />
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_absensi_bulanan}
          columns={columnsAbsensi}
          options={options}
        />
        <CustomFilterModal
          open={openCustomFilter}
          onClose={() => setOpenCustomFilter(false)}
          onApplyFilter={handleApplyCustomFilter}
          onClearFilter={handleClearCustomFilter}
          data={list_absensi_bulanan}
          cabangOptions={options_absensi_bulanan?.cabang ?? null}
          bulanOptions={options_absensi_bulanan?.bulan ?? null}
          sortableColumns={columnSort}
        />
      </Box>
    </Box>
  );
};

export default RekapAbsensiBulanan;
